export const PROJECTS = [
  { id: 'P-101', name: 'Nexus Tower Core', status: 'Active', progress: 68, health: 'Good', site: 'Sector A-1' },
  { id: 'P-102', name: 'Sector 7 Transit Hub', status: 'Delayed', progress: 42, health: 'Warning', site: 'Sector B-4' },
  { id: 'P-103', name: 'Aero Dynamics Facility', status: 'Planning', progress: 12, health: 'Good', site: 'Sector C-2' },
  { id: 'P-104', name: 'Neo-Plaza Residential', status: 'Active', progress: 89, health: 'Good', site: 'Sector A-9' }
];

export const METRICS = {
  activeSites: 14,
  criticalRFIs: 3,
  delayedDeliveries: 2,
  safetyScore: 98.5,
  manHoursToday: 1240,
  equipmentUptime: 94
};

export const RECENT_ACTIVITY = [
  { id: 1, type: 'Safety', message: 'Site audit completed. 0 critical violations.', time: '2h ago', project: 'P-101' },
  { id: 2, type: 'Material', message: 'Steel beams delivery delayed by 4 hours.', time: '4h ago', project: 'P-102', isWarning: true },
  { id: 3, type: 'RFI', message: 'RFI #042 resolved by structural engineer.', time: '5h ago', project: 'P-101' },
  { id: 4, type: 'Task', message: 'Foundation pour completed in Zone B.', time: '1d ago', project: 'P-103' },
  { id: 5, type: 'Sub', message: 'Mechanical team checked-in at Site B-4.', time: '10m ago', project: 'P-102' }
];

export const RFIS = [
  { id: 'RFI-089', title: 'HVAC routing conflict Floor 4', status: 'Open', priority: 'High', date: '2023-10-24', project: 'P-101' },
  { id: 'RFI-090', title: 'Material spec clarification for lobby', status: 'Pending', priority: 'Medium', date: '2023-10-25', project: 'P-102' },
  { id: 'RFI-091', title: 'Load bearing wall adjustment', status: 'Resolved', priority: 'Critical', date: '2023-10-20', project: 'P-101' },
  { id: 'RFI-092', title: 'Electrical panel placement', status: 'Open', priority: 'Low', date: '2023-10-26', project: 'P-103' }
];

export const TASKS = [
  { id: 'T-401', title: 'Review structural drawings', assignee: 'J. Miller', status: 'In Progress', priority: 'High', zone: 'Sector A-1' },
  { id: 'T-402', title: 'Schedule crane inspection', assignee: 'A. Smith', status: 'Todo', priority: 'Critical', zone: 'Sector B-4' },
  { id: 'T-403', title: 'Approve concrete mix design', assignee: 'S. Patel', status: 'Done', priority: 'Medium', zone: 'Sector A-1' },
  { id: 'T-404', title: 'Site perimeter fencing', assignee: 'Contractor B', status: 'In Progress', priority: 'Low', zone: 'Sector C-2' },
  { id: 'T-405', title: 'Solar Array Install', assignee: 'Volt Systems', status: 'Todo', priority: 'High', zone: 'Sector A-9' }
];

export const DELIVERIES = [
  { id: 'D-1001', material: 'Rebar Grade 60', supplier: 'SteelCo', status: 'En Route', eta: 'Today 14:00', site: 'Nexus Tower' },
  { id: 'D-1002', material: 'Pre-mixed Concrete', supplier: 'MixRight', status: 'Delayed', eta: 'Tomorrow 08:00', site: 'Sector 7' },
  { id: 'D-1003', material: 'HVAC Units (x4)', supplier: 'AirSys', status: 'Scheduled', eta: 'Oct 30', site: 'Nexus Tower' }
];

export const SUBCONTRACTORS = [
  { id: 'SUB-01', name: 'IronClad Structural', specialty: 'Steelwork', status: 'On-site', workers: 24, compliance: 100 },
  { id: 'SUB-02', name: 'Volt Systems', specialty: 'Electrical', status: 'Pending', workers: 0, compliance: 98 },
  { id: 'SUB-03', name: 'Hydra Plumbing', specialty: 'HVAC/Plumbing', status: 'On-site', workers: 12, compliance: 95 },
  { id: 'SUB-04', name: 'Eco-Landscaping', specialty: 'Exterior', status: 'Idle', workers: 0, compliance: 100 }
];

export const SAFETY_CHECKS = [
  { id: 'SAF-901', area: 'Cranes & Hoists', checker: 'R. Davis', status: 'Passed', date: 'Daily' },
  { id: 'SAF-902', area: 'Hazardous Waste', checker: 'S. Lee', status: 'Failed', date: 'Weekly', note: 'Leak detected in Sector B.' },
  { id: 'SAF-903', area: 'PPE Compliance', checker: 'Auto-AI Cam', status: 'Warning', date: 'Live', note: '2 workers missing vests.' }
];